import { http, HttpResponse } from 'msw'
import V1_AUTH_SIGNIN_RES from '../responses/v1/post-auth-signin';
import V1_USERS_ME_RES from '../responses/v1/get-users-me';
import V1_ADMIN_SETTINGS_RES from '../responses/v1/get-admin-settings';
import V1_TRADE_PROFILE_RES from '../responses/v1/get-trade-profile';
import V1_TRADE_PROFILE_ID_RES from '../responses/v1/get-trade-profile-id';
import V1_TEAM_RES from '../responses/v1/get-team';
import V1_WAITLIST_RES from '../responses/v1/get-waitlist';
import V1_CHECK_EMAIL_TOKEN_RES from '../responses/v1/get-check-email-token';

const BASE_URL = "http://localhost:8080";

export const handlers = [
  http.post(`${BASE_URL}/v1/auth/signin`, async ({ request }) => {
    try {
      const body: any = await request.json()
      if (body?.email === 'uninvited@test.com') {
        return HttpResponse.json({
          statusCode: 403,
          message: 'LOGIN.ERROR.NOT_INVITED',
          error: 'Forbidden'
        }, { status: 403 })
      }
    } catch (e) {}
    return HttpResponse.json(V1_AUTH_SIGNIN_RES, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/users/me`, () => {
    return HttpResponse.json(V1_USERS_ME_RES, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/admin-settings`, () => {
    return HttpResponse.json(V1_ADMIN_SETTINGS_RES, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/trade-profile`, () => {
    return HttpResponse.json(V1_TRADE_PROFILE_RES, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/trade-profile/:id`, ({params}) => {
    const { id } = params;
    return HttpResponse.json({ ...V1_TRADE_PROFILE_ID_RES, id }, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/team`, () => {
    return HttpResponse.json(V1_TEAM_RES, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/waitlist`, () => {
    return HttpResponse.json(V1_WAITLIST_RES, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/event-role`, () => {
    return HttpResponse.json([
      {
        id: 'donor-role-id',
        name: 'Donor',
        level: 20,
        eventId: 'cm5evt0010000event000001',
      },
      {
        id: 'angler-role-id',
        name: 'Angler',
        level: 10,
        eventId: 'cm5evt0010000event000001',
      }
    ], { status: 200 })
  }),
  http.post(`${BASE_URL}/v1/event/:eventId/invite`, async ({ request }) => {
    try {
      const body: any = await request.json()
      return HttpResponse.json({
        id: 'invite-1',
        ...body
      }, { status: 201 })
    } catch (e) {
      return HttpResponse.json({ error: 'Invalid payload' }, { status: 400 })
    }
  }),
  http.get(`${BASE_URL}/v1/check/:email/:token`, ({params}) => {
    return HttpResponse.json(V1_CHECK_EMAIL_TOKEN_RES, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/user-invite/check/:email/:token`, ({params}) => {
    return HttpResponse.json({ accepted: false }, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/users/exists/:email`, ({params}) => {
    return HttpResponse.json("exists", { status: 200 })
  }),
  http.post(`${BASE_URL}/v1/auth/signup`, (_) => {
    return HttpResponse.json("success", { status: 200 })
  }),
  http.post(`${BASE_URL}/v1/auth/invite-signup`, (_) => {
    return HttpResponse.json("success", { status: 200 })
  }),
  http.post(`${BASE_URL}/v1/auth/judge-signup`, (_) => {
    return HttpResponse.json("success", { status: 200 })
  }),
  http.post(`${BASE_URL}/v1/auth/leader-signup`, (_) => {
    return HttpResponse.json("success", { status: 200 })
  }),
  http.post(`${BASE_URL}/v1/auth/angler-signup`, (_) => {
    return HttpResponse.json("success", { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/auth/email/verify/:verificationCode`, (_) => {
    return HttpResponse.json("success", { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/auth/refresh`, () => {
    return HttpResponse.json("success", { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/admin-settings/description/:description`, () => {
    return HttpResponse.json({ id: 99, description: 'maintenanceMode', status: false, value: null, text: null, date: null }, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/event/my`, () => {
    return HttpResponse.json([
      { id: 'cm5evt0010000event000001', name: 'Borracho Pescador 2026', label: 'bp-2026', createdAt: '2026-01-01T00:00:00.000Z', updatedAt: '2026-01-01T00:00:00.000Z' },
    ], { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/event-features`, () => {
    return HttpResponse.json({
      id: 'cm5evt0010000event000001',
      teamChanges: false,
      scoreboard: false,
      raffle: true,
      auction: true,
      registration: false,
    }, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/announcements`, () => {
    return HttpResponse.json([], { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/participant/my`, () => {
    return HttpResponse.json([], { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/participant/my/all`, () => {
    return HttpResponse.json([], { status: 200 })
  }),
  http.patch(`${BASE_URL}/v1/participant/:id/accept`, () => {
    return HttpResponse.json({ status: 'ACCEPTED' }, { status: 200 })
  }),
  http.patch(`${BASE_URL}/v1/participant/:id/decline`, () => {
    return HttpResponse.json({ status: 'DECLINED' }, { status: 200 })
  }),
  http.get(`${BASE_URL}/v1/auth/check-event-invite/:email/:token`, () => {
    return HttpResponse.json({ valid: true }, { status: 200 })
  }),
  http.post(`${BASE_URL}/v1/auth/event-invite-signup`, () => {
    return HttpResponse.json("success", { status: 200 })
  }),
  http.post(`${BASE_URL}/v1/auth/logout`, () => {
    return HttpResponse.json("success", { status: 200 })
  }),
  http.post(`${BASE_URL}/v1/vendor-inquiry`, () => {
    return HttpResponse.json({ id: 'msw_default', status: 'new' }, { status: 201 })
  })
]
